import styled from "styled-components";

export const Table = styled.table`
  overflow-x: scroll;
  text-align: start;
  border-collapse: separate;
  border-spacing: 0 0.35rem;
  width: 90w;
  padding-right: 4vw;
  padding-left: 4vw;
  margin: 0.4rem;

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0.7vw;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0.7vw;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 0.7vw;
  }
  

  tr:last-child td:last-child {
    border-bottom-right-radius: 0.7vw;
  }
  tr:last-child td:first-child {
    border-top-left-radius: 0.7vw;
  }
  

  tr:last-child td:last-child {
    border-top-right-radius: 0.7vw;
  }
`

export const HeaderRow = styled.tr`
  position: sticky;
  top: 0;
  height: 2.2rem;
`

export const ItemRow = styled.tr`
  height: 2.4rem;
  background-color: #fff;

  &:hover{
    background-color:#F7F7F7;
    
    .edit-div{
      visibility:visible;
    }
  }
`

export const HeaderCell = styled.th`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: 0.7rem;
  padding-left: 1.2rem;
`

export const ItemCell = styled.td`
  width: 15vw;
  text-align: start;
  font-size: 12px;
  padding-left: 1.2rem;
  border-bottom: solid 1px #ebebeb;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

export const ItemCellContainer = styled.div`
  display:flex;
  gap:0.3vw;
  align-items:center;

  .documentUrl {
    cursor:pointer;
    &:hover {
    color: #0090d3;
    }
  }
`


export const ImageCell = styled.td`
  
  width: 5vw;
  text-align: start;
  font-size: 14px;
  padding-left: 1vw;
  border-bottom: solid 1px #EBEBEB;
  word-wrap: break-word;
  overflow-wrap: break-word;
`
export const OptionsImage = styled.img`
  cursor: pointer;
  padding-left: 1.5rem;
`

export const StatusText = styled.span`
  display: flex;
  justify-content: center;
  padding: .5rem 1rem;
  border-radius: 2rem;
  font-size: 10px;
  display: flex;
  align-items: center;
  gap: .5rem;
  font-weight: 400;
  user-select: none;
  background-color: #c2c2c2;
  color: #464543;
  width: fit-content;

  &.completed{
    color: #67C97E;
    background-color:rgba(179, 228, 191, 0.3);
  }
 
  &.pending{
    background-color: #FFFCEE;
    color: #9D7D07;
  }

  &.cancel{
    background-color:rgba(245, 142, 142, 0.3);
    color: #9d1e07;
  }

`
export const EditDiv = styled.div`
  height: 1.5rem;
  width: 1.5rem;
  background-color: #ededed;
  border: 1px solid #848484;
  display:flex;
  justify-content:center;
  align-items:center;
  border-radius: 25%;
  filter:grayscale(1);
  visibility:hidden;
  
  &:hover{
    background-color:#fff;
    border: 1px solid #0090D3;
    filter:grayscale(0);
  }
`

export const FreightStatusDots = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
`

export const FreightStatusDot = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 12px;
  font-weight: 600;
  color: #464543;
  user-select: none;

  i {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #c2c2c2;
  }

  &.pending i {
    background-color: #0090D3;
  }

  &.notDelivered i {
    background-color: #D9534F;
  }

  &.completed i {
    background-color: #41BB5E;
  }
`
